import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg, { getWebPageSchema, faqPageSchema } from '@/components/feature/SchemaOrg';
import { testimonials } from '@/mocks/movies';
import { Helmet } from '@/pages/home/components/SEO';

export default function AboutPage() {
  return (
    <>
      <Helmet
        title="关于被窝网电影 - 免费高清影视资源聚合平台"
        description="被窝网电影是一家专注于免费高清影视资源聚合的平台，提供海量电影电视剧在线观看服务。了解我们的品牌故事、用户口碑和联系方式。"
        keywords="被窝网电影,关于被窝网,电影网站介绍,联系我们,影视平台,免费电影"
        canonicalUrl="/about"
      />
      <SchemaOrg schema={faqPageSchema} />
      <SchemaOrg schema={getWebPageSchema(
        '关于被窝网电影 - 免费高清影视资源聚合平台',
        '被窝网电影是一家专注于免费高清影视资源聚合的平台，提供海量电影电视剧在线观看服务。',
        '/about',
        [
          { name: '首页', url: '/' },
          { name: '关于我们', url: '/about' },
        ]
      )} />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="w-full bg-background-100 py-10 md:py-16">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <div className="text-center mb-10">
                  <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                    关于被窝网电影
                  </h1>
                  <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                    被窝网电影大全，您的私人影院。致力于为广大影迷提供最优质的免费高清影视资源聚合服务。
                  </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
                  <div className="p-6 md:p-8 rounded-lg bg-background-50">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-4">
                      <i className="ri-lightbulb-line text-xl" />
                    </div>
                    <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">
                      品牌故事
                    </h2>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      被窝网电影诞生于对电影的热爱。我们深知在忙碌的生活中，窝在被窝里看一部好电影是最简单也最幸福的享受。因此，我们创建了这个平台，希望每个人都能轻松找到想看的电影电视剧，享受高清流畅的观影体验。
                    </p>
                    <p className="text-sm text-foreground-600 leading-relaxed mt-3">
                      自成立以来，被窝网电影始终坚持"资源全、画质高、播放快"的核心理念。我们聚合了全网优质的影视资源，覆盖动作、喜剧、爱情、科幻、恐怖、悬疑等十余种类型，以及海量热门电视剧，满足不同观众的观影需求。
                    </p>
                  </div>

                  <div className="p-6 md:p-8 rounded-lg bg-background-50">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                      <i className="ri-trophy-line text-xl" />
                    </div>
                    <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">
                      我们的优势
                    </h2>
                    <ul className="space-y-3">
                      <li className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-accent-500 mt-0.5 shrink-0" />
                        <div>
                          <strong className="text-sm font-medium text-foreground-900">海量片源</strong>
                          <p className="text-xs text-foreground-500 mt-0.5">聚合全网资源，超过950部影视作品，覆盖主流电影和热门电视剧</p>
                        </div>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-accent-500 mt-0.5 shrink-0" />
                        <div>
                          <strong className="text-sm font-medium text-foreground-900">高清画质</strong>
                          <p className="text-xs text-foreground-500 mt-0.5">全站资源均提供高清画质，支持多分辨率切换</p>
                        </div>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-accent-500 mt-0.5 shrink-0" />
                        <div>
                          <strong className="text-sm font-medium text-foreground-900">流畅不缓冲</strong>
                          <p className="text-xs text-foreground-500 mt-0.5">采用CDN加速和高速服务器，确保播放流畅无卡顿</p>
                        </div>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-accent-500 mt-0.5 shrink-0" />
                        <div>
                          <strong className="text-sm font-medium text-foreground-900">完全免费</strong>
                          <p className="text-xs text-foreground-500 mt-0.5">所有资源免费观看，无需注册登录，无隐藏收费</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="w-full py-10 md:py-14">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <div className="text-center mb-8">
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                    用户口碑
                  </h2>
                  <p className="mt-2 text-sm text-foreground-500">
                    听听影迷们怎么说
                  </p>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {testimonials.map((t, index) => (
                    <div key={index} className="p-5 rounded-lg bg-background-100">
                      <div className="flex items-center gap-1.5 mb-3">
                        {Array.from({ length: 5 }).map((_, i) => (
                          <i
                            key={i}
                            className={`text-sm ${
                              i < t.rating
                                ? 'ri-star-fill text-accent-500'
                                : 'ri-star-line text-foreground-300'
                            }`}
                          />
                        ))}
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                        &ldquo;{t.content}&rdquo;
                      </p>
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 text-xs font-bold">
                            {t.author[0]}
                          </div>
                          <span className="text-sm font-medium text-foreground-900">
                            {t.author}
                          </span>
                        </div>
                        <span className="text-xs text-foreground-400">{t.date}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section id="contact" className="w-full py-10 md:py-14 bg-background-100">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <div className="text-center mb-8">
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                    联系我们
                  </h2>
                  <p className="mt-2 text-sm text-foreground-500">
                    有任何问题或建议，欢迎随时联系
                  </p>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-4xl mx-auto">
                  <div className="space-y-5">
                    <div className="flex items-start gap-4 p-4 rounded-lg bg-background-50">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 shrink-0">
                        <i className="ri-mail-line text-lg" />
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                        <p className="text-sm text-foreground-500">contact@beiwomovie.com</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4 p-4 rounded-lg bg-background-50">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0">
                        <i className="ri-wechat-line text-lg" />
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</h3>
                        <p className="text-sm text-foreground-500">被窝网电影</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4 p-4 rounded-lg bg-background-50">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0">
                        <i className="ri-weibo-line text-lg" />
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-900 mb-1">新浪微博</h3>
                        <p className="text-sm text-foreground-500">@被窝网电影官方微博</p>
                      </div>
                    </div>
                  </div>
                  <ContactForm />
                </div>
              </div>
            </div>
          </section>

          <section className="w-full py-10 md:py-14">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-3xl mx-auto">
                <div className="text-center mb-8">
                  <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                    常见问题
                  </h2>
                  <p className="mt-2 text-sm text-foreground-500">
                    关于被窝网电影的常见疑问解答
                  </p>
                </div>
                <div className="space-y-3">
                  {faqPageSchema.mainEntity.map((faq, idx) => (
                    <details key={idx} className="p-5 rounded-lg bg-background-100 cursor-pointer group">
                      <summary className="flex items-center justify-between text-sm font-medium text-foreground-900">
                        {faq.name}
                        <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform" />
                      </summary>
                      <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                        {faq.acceptedAnswer.text}
                      </p>
                    </details>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}

function ContactForm() {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const phoneAlt = formData.get('phone_alt') as string;
    if (phoneAlt && phoneAlt.trim() !== '') {
      const successEl = form.querySelector('.form-success') as HTMLElement;
      if (successEl) successEl.style.display = 'block';
      return;
    }
    const submitBtn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = '发送中...';
    }
    fetch('https://readdy.ai/api/form/d9nh7268mbnljin5a0l0', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(
        Array.from(formData.entries())
          .filter(([key]) => key !== 'phone_alt')
          .map(([k, v]) => [k, v.toString()])
      ).toString(),
    })
      .then(async (res) => {
        const text = await res.text();
        let parsed;
        try { parsed = JSON.parse(text); } catch { parsed = { code: 'Error' }; }
        if (res.ok && parsed?.code === 'OK') {
          form.reset();
          const successEl = form.querySelector('.form-success') as HTMLElement;
          if (successEl) successEl.style.display = 'block';
          const errorEl = form.querySelector('.form-error') as HTMLElement;
          if (errorEl) errorEl.style.display = 'none';
        } else {
          const errorEl = form.querySelector('.form-error') as HTMLElement;
          if (errorEl) {
            errorEl.textContent = parsed?.meta?.message || '发送失败，请稍后重试';
            errorEl.style.display = 'block';
          }
        }
      })
      .catch(() => {
        const errorEl = form.querySelector('.form-error') as HTMLElement;
        if (errorEl) {
          errorEl.textContent = '网络错误，请检查网络后重试';
          errorEl.style.display = 'block';
        }
      })
      .finally(() => {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = '发送消息';
        }
      });
  };

  return (
    <form
      data-readdy-form=""
      id="contact-form"
      onSubmit={handleSubmit}
      className="p-6 rounded-lg bg-background-50 space-y-4"
    >
      <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
        发送消息
      </h3>
      <div>
        <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
          姓名
        </label>
        <input
          id="contact-name"
          name="name"
          type="text"
          required
          className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-900 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors"
          placeholder="请输入您的姓名"
        />
      </div>
      <div>
        <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
          邮箱
        </label>
        <input
          id="contact-email"
          name="email"
          type="email"
          required
          className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-900 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors"
          placeholder="请输入您的邮箱"
        />
      </div>
      <div>
        <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
          留言
        </label>
        <textarea
          id="contact-message"
          name="message"
          rows={4}
          required
          maxLength={500}
          className="w-full px-4 py-2.5 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-900 outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors resize-none"
          placeholder="请输入您的留言（500字以内）"
        />
      </div>
      <div className="antispam-field">
        <input
          type="text"
          name="phone_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
      </div>
      <div className="form-success hidden p-3 rounded-lg bg-accent-50 text-accent-700 text-sm">
        消息已发送成功，我们会尽快回复您！
      </div>
      <div className="form-error hidden p-3 rounded-lg bg-primary-50 text-primary-700 text-sm" />
      <button
        type="submit"
        className="w-full px-6 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
      >
        发送消息
      </button>
    </form>
  );
}